import { render, staticRenderFns } from "./UserDevice.vue?vue&type=template&id=72880bca&"
import script from "./UserDevice.vue?vue&type=script&lang=js&"
export * from "./UserDevice.vue?vue&type=script&lang=js&"
import style0 from "./UserDevice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports